/**
 * Toggle — the canonical on/off switch (see DESIGN.md "Toggles"), now an
 * Astryx Switch behind the same API.
 *
 * Flipping it IS the commit: callers save on change and pass `disabled`
 * while the mutation is in flight, reverting on failure. Label/description
 * live in the setting row; the switch is named via aria-label (the Astryx
 * Switch doesn't forward aria-labelledby to its input) — the Switch's own
 * label stays visually hidden.
 */
import { Switch } from "@astryxdesign/core/Switch";

export function Toggle({
  checked,
  onChange,
  disabled = false,
  "aria-label": ariaLabel,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  "aria-label"?: string;
}) {
  return (
    <Switch
      label={ariaLabel ?? "Toggle"}
      isLabelHidden
      value={checked}
      onChange={(next) => onChange(next)}
      isDisabled={disabled}
    />
  );
}
